<template lang="pug">
.card
  .card-header
    i(:class="icon")
    p.title(v-if="title") {{ title }}
  .card-body
    .type {{ cardType }}
    .total
      .value {{ value }}
      .subValue cadastros
</template>

<script>

export default {
  props: {
    title: String,
    value: Number,
    type: String
  },
  data () {
    return {
      cardType: '',
      icon: ''
    }
  },
  created () {
    switch (this.type) {
      case 'qtdeCadastro':
        this.cardType = 'Total de cadastros'
        this.icon = 'fas fa-mobile-alt'
        break
      case 'nomeMunicipioMaisCadastros':
        this.cardType = 'Município com mais cadastros nos últimos 7 dias'
        this.icon = 'fas fa-map-marker-alt'
        break
      case 'numeroOSMaisCadastros':
        this.cardType = 'Ordem de serviço com mais cadastros nos últimos 7 dias'
        this.icon = 'fas fa-users'
        break
      case 'nomeCadastranteMaisCadastros':
        this.cardType = 'Cadastrante com mais cadastros nos últimos 7 dias'
        this.icon = 'fas fa-user'
        break
      default:
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.card {

  @media (max-width: 780px){
  align-items: center;
  width: 50%;
  background-color: #009f60;
  height: 150px;
  color: white;
  border-radius: 15px;
  margin: 2% 0;
  box-shadow: none;
  -webkit-box-shadow: none;
  }

  p {
    color: white !important;
  }

  width: 23%;
  background-color: #009f60;
  height: 150px;
  color: white;
  border-radius: 15px;
  margin: 2% 0;
  box-shadow: none;
  -webkit-box-shadow: none;

  .card-header {
    height: 50%;
    padding: 15px 23px 10px;
    width: 100%;
    box-sizing: border-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: flex-start;
    background-color: transparent;

    .title {
      font-size: 1.15rem;
      margin: 0 0 0 23px !important;
      word-wrap: break-word;
      white-space: pre-wrap;
      word-break: break-word;
    }
  }

  .card-body {
    height: 50%;
    color: white !important;
    display: -ms-flexbox;
    display: flex;
    padding: 5px 23px;
    justify-content: space-between;

    .type {
      font-size: 0.8rem;
      width: 70%;
      margin-right: 20px;
    }

    .value {
      font-size: 1.8rem;
      text-align: right;
    }
    .subValue {
      font-size: 0.8rem;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_reurb/components/Card.vue